/**
 * F7. Готовка: 3 ингредиента из 6, правильного ответа нет — первый
 * выбранный задаёт текст блюда. Отношения +2 в любом случае.
 */
import { t } from '@life/i18n';
import { COOKING_RELATIONS, type CookingInput, type CookingState } from '@life/minigames';
import { useState } from 'preact/hooks';
import type { MinigameScreenProps } from './types';
import { Pick } from './ui/Pick';

export function Cooking({ state, onInput }: MinigameScreenProps<CookingInput, CookingState>) {
  const [picks, setPicks] = useState<number[]>([]);
  return (
    <>
      <p class="hint">{t('ui.minigame.cooking.rules', { n: state.picks, total: state.ingredients.length, r: COOKING_RELATIONS })}</p>
      <Pick label={t('ui.minigame.cooking.label')} items={state.ingredients.map((key) => ({ text: t(key) }))} max={state.picks} value={picks} onChange={setPicks} />
      <button type="button" class="btn accent block" disabled={picks.length < state.picks} onClick={() => onInput({ picks })}>
        {t('ui.minigame.cooking.cook')}
      </button>
    </>
  );
}
